import * as React from "react";

class StoryDDialogText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <g className="storyD-dialog-text">
        <path
          fill="#E77452"
          d="M182.6,315.4v10.4h-3.5v-8h-15.8v8h-3.4v-10.5L182.6,315.4L182.6,315.4z M161.9,326.7h18.9v14.5h-3.5v-0.8
		h-12.1v1h-3.4L161.9,326.7L161.9,326.7z M177.9,321.5h-13.1v-2.3h13.1V321.5z M164.8,325.1v-2.3h13.1v2.3H164.8z M165.2,329.1v1.3
		h12.1v-1.3H165.2z M177.4,334.1v-1.3h-12.1v1.3H177.4z M177.4,337.8v-1.4h-12.1v1.4H177.4z"
        />
        <path
          fill="#E77452"
          d="M200.1,321.5c-0.9,0.6-1.9,1.3-2.9,1.8c-0.4-0.6-1.4-1.7-2.1-2.3c-0.3,1.1-0.6,2.1-0.9,3
		c1.5,2.2,1.8,4.3,1.8,6c0,1.9-0.3,3.2-1.2,3.8c-0.4,0.4-0.9,0.6-1.5,0.6c-0.5,0.1-1.1,0.1-1.7,0.1c0-0.8-0.3-2.1-0.7-3
		c0.4,0.1,0.8,0.1,1.1,0c0.2,0,0.5-0.1,0.7-0.2c0.3-0.3,0.4-0.9,0.4-1.8c0-1.3-0.2-3.3-1.6-5.3c0.5-1.7,1-4.1,1.4-6.1h-2.1v22.9
		h-2.9v-26h5.9l0.5-0.1l2.2,1.3c-0.4,1.4-0.8,2.9-1.2,4.4c3.3-1.7,6.4-4.4,8-7.1l3.3,1.2c-0.2,0.3-0.4,0.6-0.6,0.9
		c2.2,1.7,5.3,3.5,8.2,4.4c-0.5,0.9-1.1,2.4-1.3,3.3c-1.4-0.6-2.8-1.3-4.1-2.2v1.9h-8.6L200.1,321.5L200.1,321.5z M202,332.9
		c-0.2,0.6-0.4,1.2-0.6,1.7c1,0.7,2.2,1.5,2.8,2.1l-1.7,2.3c-0.5-0.6-1.4-1.3-2.3-2c-1.1,1.8-2.5,3.2-4.2,4.3
		c-0.5-0.6-1.6-1.7-2.2-2.2c2.6-1.5,4.4-4,5.3-6.9L202,332.9z M196.7,324.7h7v7.3h-7V324.7z M199.2,329.7h2V327h-2V329.7z
		 M207.6,320.6c-1.3-0.8-2.4-1.7-3.4-2.6c-0.9,0.9-1.8,1.8-2.8,2.6H207.6z M210.1,332.7c-0.2,0.8-0.4,1.6-0.7,2.4
		c1.6,1.1,3.5,2.5,4.5,3.5l-2,2.3c-0.8-0.9-2.2-2.1-3.7-3.1c-0.9,1.5-2,2.7-3.2,3.6c-0.4-0.6-1.5-1.7-2.2-2.2
		c2.3-1.5,3.7-3.9,4.2-6.9L210.1,332.7z M205,324.7h7.2v7.3H205V324.7z M207.5,329.7h2V327h-2V329.7z"
        />
        <path
          fill="#E77452"
          d="M242.9,328.3c-1.2,1.2-2.6,2.4-3.8,3.4c0.9,2.7,2.2,4.9,4,6.2c-0.8,0.6-1.8,2-2.3,2.9
		c-3.6-2.9-5.2-8.3-6.1-14.8c-0.6,0.1-1.3,0.3-1.9,0.4v9.8l3.6-1.4c0,1,0.2,2.4,0.4,3.1c-5.3,2.2-6.3,2.7-6.9,3.2
		c-0.3-0.7-1.2-1.9-1.7-2.4c0.6-0.5,1.3-1.5,1.3-3v-10.7l-0.1,0.1c-0.6-0.6-2-1.7-2.8-2.1c0.4-0.4,0.7-0.7,1-1.1h-5.4v2.8h5.3
		c0,0,0,1,0,1.4c-0.2,9.2-0.5,12.6-1.2,13.7c-0.5,0.8-1.1,1.1-1.9,1.2c-0.7,0.1-1.7,0.1-2.9,0.1c-0.1-0.9-0.4-2.2-0.8-3
		c0.8,0.1,1.6,0.1,2.1,0.1c0.4,0,0.6-0.1,0.8-0.4c0.4-0.6,0.6-3.1,0.8-9.9h-2.1c-0.2,4.3-1,9.3-4,13.5c-0.6-0.6-1.7-1.5-2.5-1.9
		c3.1-4.5,3.5-9.6,3.5-13.6v-4h-2.7v-3.2h5c-0.3-1.1-0.8-2.5-1.3-3.6l3-0.9c0.6,1.2,1.2,2.8,1.5,3.9l-2,0.7h5.2v3
		c1.5-2,2.7-4.7,3.3-7.5l3.3,0.6c-0.2,1-0.5,2-0.8,2.9h9.2v3.1h-10.5c-0.6,1.3-1.3,2.4-2.1,3.4c3.5-0.8,7.3-1.9,9.6-3l2.7,2.4
		c-1.4,0.6-3,1.1-4.7,1.6c0.1,1.2,0.4,2.3,0.6,3.4c0.8-0.8,1.7-1.7,2.2-2.4L242.9,328.3z"
        />
        <path
          fill="#E77452"
          d="M254.3,333.4c-0.4-1-1.1-2.4-1.8-3.7v11.6h-3.3v-10.8c-0.8,2.4-1.8,4.7-2.9,6.3c-0.3-1-1-2.6-1.5-3.4
		c1.4-1.9,2.7-5,3.6-7.8h-3.2v-3.2h4v-3.5c-0.9,0.2-1.9,0.4-2.7,0.5c-0.1-0.8-0.6-2-0.9-2.7c3-0.5,6.3-1.4,8.4-2.4l1.8,2.9
		c-1,0.4-2.1,0.8-3.3,1v4.2h3.3v3.2h-3.3v0.5c0.8,0.8,3.1,3.9,3.6,4.6L254.3,333.4z M272.1,337.7v3.1h-16.8v-3.1h7V335h-5.5v-3h5.5
		v-2.4c-1.5,0.1-3.1,0.2-4.6,0.3c-0.1-0.8-0.5-1.9-0.8-2.6c4.2-0.3,8.9-0.8,11.9-1.6l2.1,2.6c-1.5,0.4-3.3,0.7-5.2,0.9v2.7h5.2v3
		h-5.2v2.7L272.1,337.7L272.1,337.7z M270.7,325.4h-13.8v-10h13.8V325.4z M267.4,318.3h-7.3v4.2h7.3V318.3z"
        />
        <path
          fill="#E77452"
          d="M284,325.3c0.8,2,1.6,4.5,1.8,6.1l-2.6,0.9c-0.1-0.4-0.1-0.9-0.3-1.3c-5.9,0.8-6.9,1.1-7.6,1.4
		c-0.2-0.6-0.7-2.2-1-3c0.8-0.2,1.4-0.8,2.3-1.9c0.4-0.4,1.1-1.3,1.9-2.4c-2.3,0.3-3,0.4-3.4,0.6c-0.2-0.6-0.7-2.1-1-2.9
		c0.6-0.1,1-0.7,1.7-1.6c0.6-0.8,2.5-4.1,3.6-7.2l3.1,1.3c-1.1,2.4-2.6,4.9-4.1,7l2.1-0.1c0.7-1.2,1.4-2.4,2-3.7l2.8,1.8
		c-1.7,2.9-3.8,5.9-6,8.4l3-0.3c-0.2-0.8-0.5-1.5-0.7-2.2L284,325.3z M278.1,333.7c-0.2,2.6-0.7,5.4-1.3,7.2
		c-0.6-0.3-1.9-0.7-2.6-0.9c0.7-1.7,1-4.3,1.2-6.7L278.1,333.7z M281.2,333.1c0.4,2.1,0.8,4.8,0.9,6.6l-2.6,0.5
		c-0.1-1.8-0.4-4.5-0.7-6.6L281.2,333.1z M284.2,332.3c0.7,1.8,1.4,4.1,1.6,5.7l-2.4,0.8c-0.2-1.5-0.9-4-1.5-5.8L284.2,332.3z
		 M294.9,320.9v3.3h5.5v3.2h-14.1v-3.2h5.1v-3.3h-5.9v-3.2h5.9v-3.6h3.6v3.6h6.2v3.2H294.9z M286.8,329.6h12.9v11.6h-3.4v-1.1h-6.3
		v1.3h-3.2L286.8,329.6L286.8,329.6z M290.1,332.7v4.2h6.3v-4.2H290.1z"
        />
        <path
          fill="#E77452"
          d="M320.8,331.6c2.5,2.5,6.3,4.8,9.9,6c-0.8,0.7-1.9,2.1-2.5,3.1c-3.4-1.5-6.8-3.8-9.4-6.7v7.3h-3.6v-7.1
		c-2.7,2.7-6,5-9.4,6.4c-0.6-0.9-1.6-2.2-2.4-2.9c3.6-1.3,7.4-3.6,9.9-6.1h-6.9v-9.3h8.7V320h-10.6v-3.2h10.6v-2.7h3.6v2.7h10.7v3.2
		h-10.7v2.3h9v9.3L320.8,331.6L320.8,331.6z M309.9,328.6h5.3v-3.3h-5.3V328.6z M318.8,325.3v3.3h5.4v-3.3H318.8z"
        />
        <path
          fill="#E77452"
          d="M341.7,321.4c-0.6,1.3-1.4,2.6-2.3,3.8v16.1h-3.3v-12.1c-0.6,0.6-1.3,1.2-1.8,1.7c-0.3-0.7-1.3-2.5-1.8-3.2
		c2.3-1.8,4.8-4.6,6.2-7.5L341.7,321.4z M341.2,315.3c-1.7,2.6-4.3,5.4-6.6,7.1c-0.4-0.7-1.3-1.9-1.8-2.5c2-1.5,4.3-3.9,5.4-5.8
		L341.2,315.3z M357.4,330c-1.1,2.7-2.8,4.8-4.9,6.6c2,0.8,4.3,1.5,6.8,1.9c-0.7,0.7-1.6,2.1-2.1,3c-3-0.6-5.7-1.5-7.9-2.8
		c-2.4,1.3-5.2,2.2-8,2.8c-0.3-0.9-1-2.2-1.6-2.9c2.4-0.4,4.6-1,6.6-1.9c-0.7-0.5-1.3-1.1-1.9-1.7c-0.6,0.6-1.3,1.1-1.9,1.5
		c-0.5-0.6-1.6-1.9-2.3-2.5c0.7-0.5,1.4-1,2.1-1.5c-0.6-0.8-1.1-1.7-1.5-2.6l2.8-0.9c0.2,0.5,0.5,1,0.8,1.4c0.8-0.9,1.4-1.8,2-2.8
		c-3.1,0.3-4,0.4-4.6,0.6c-0.1-0.6-0.6-2.3-1-3.1c1-0.1,1.9-0.6,3.3-1.4c0.5-0.3,1.5-0.8,2.7-1.5c-3,0.1-3.8,0.3-4.3,0.5
		c-0.2-0.7-0.7-2.4-1.1-3.3c0.6-0.1,1.2-0.5,2-1c0.8-0.5,3.1-2.2,4.7-4.1l3.5,1.5c-1.4,1.3-3,2.6-4.7,3.7l3.8-0.1
		c1.1-0.9,2.2-1.8,3.1-2.7l3.2,1.7c-2.9,2.4-6,4.5-9.2,6.2l6.1-0.3c-0.4-0.6-0.8-1.1-1.2-1.7l2.7-1.4c1.5,2,3.5,4.6,4.4,6.3
		l-2.9,1.6c-0.3-0.7-0.8-1.5-1.3-2.4l-5.4,0.4c-0.3,0.7-0.7,1.3-1,2h5.5l0.6-0.1L357.4,330z M347.2,331.9c-0.2,0.3-0.5,0.6-0.7,0.8
		c0.8,0.8,1.8,1.6,2.9,2.2c1.3-0.9,2.4-1.9,3.3-3.1H347.2z"
        />
        <path
          fill="#E77452"
          d="M364.6,339.9c2.3-0.7,3.6-2,3.8-3.5c-0.1,0-0.2,0-0.3,0c-1.5,0-2.8-0.9-2.8-2.6c0-1.6,1.3-2.6,2.9-2.6
		c2.1,0,3.1,1.5,3.1,4c0,3.3-2.1,6-5.7,7.1L364.6,339.9z"
        />
        <path
          fill="#E77452"
          d="M378,317.2h13.2v3.6h-8.9v5h7.6v3.6h-7.6v5.8h9.2v3.6H378L378,317.2L378,317.2z"
        />
        <path
          fill="#E77452"
          d="M394.7,334.3c0-3.5,2.8-5.3,9.4-6c-0.1-1.6-0.8-2.8-2.8-2.8c-1.5,0-3,0.7-4.5,1.5l-1.5-2.8
		c1.9-1.2,4.3-2.2,6.8-2.2c4.1,0,6.3,2.5,6.3,7.2v9.5h-3.5l-0.3-1.7h-0.1c-1.4,1.2-3.1,2.2-4.9,2.2
		C396.6,339.2,394.7,337.1,394.7,334.3z M404.1,334.2v-3.3c-4,0.5-5.3,1.6-5.3,3.1c0,1.3,0.9,1.8,2.2,1.8
		C402.2,335.8,403.1,335.2,404.1,334.2z"
        />
        <path
          fill="#E77452"
          d="M411.2,336.9l2-2.7c1.5,1.1,2.9,1.8,4.4,1.8c1.6,0,2.4-0.7,2.4-1.7c0-1.2-1.7-1.8-3.4-2.4
		c-2.1-0.8-4.5-2-4.5-4.8c0-2.9,2.4-5,6.1-5c2.4,0,4.2,1,5.6,2l-1.9,2.6c-1.2-0.8-2.3-1.4-3.5-1.4c-1.5,0-2.2,0.6-2.2,1.6
		c0,1.2,1.6,1.6,3.3,2.3c2.2,0.8,4.5,1.9,4.5,4.9c0,2.9-2.2,5.2-6.5,5.2C415.2,339.2,412.8,338.2,411.2,336.9z"
        />
        <path
          fill="#E77452"
          d="M426.2,330.6c0-5.5,3.8-8.6,7.8-8.6s7.8,3.1,7.8,8.6c0,5.4-3.8,8.5-7.8,8.5S426.2,336,426.2,330.6z
		 M437.5,330.6c0-3.1-1.3-5.1-3.5-5.1s-3.5,2-3.5,5.1c0,3.1,1.3,5,3.5,5S437.5,333.7,437.5,330.6z"
        />
        <path
          fill="#E77452"
          d="M445.4,322.5h3.5l0.3,2.2h0.1c1.4-1.4,3.1-2.6,5.3-2.6c3.5,0,5,2.4,5,6.6v10.2h-4.3v-9.6
		c0-2.5-0.7-3.4-2.3-3.4c-1.3,0-2.2,0.6-3.4,1.8v11.2h-4.3L445.4,322.5L445.4,322.5z"
        />
        <path
          fill="#E77452"
          d="M472.8,329.7c-1.1,0.3-2.2,0.6-3.3,0.9v7c0,1.6-0.3,2.4-1.2,3c-0.9,0.5-2.2,0.6-4,0.6c-0.1-0.9-0.5-2.3-1-3.2
		c0.9,0.1,1.9,0.1,2.2,0c0.4,0,0.5-0.1,0.5-0.5v-6.2c-1,0.3-1.9,0.5-2.8,0.7l-0.8-3.3c1-0.2,2.3-0.5,3.6-0.8v-5.3H463v-3.2h3.1v-5.5
		h3.4v5.5h2.7v3.2h-2.7v4.4l2.8-0.7L472.8,329.7z M484.7,337.3c1.6,0,1.9-0.8,2.2-4c0.8,0.6,2.3,1.2,3.4,1.4c-0.5,4.4-1.6,6-5.2,6
		h-6.3c-4,0-5.3-1.1-5.3-5.4v-19.8h15.5v16.3h-3.6v-1.8h-8.2v5.4c0,1.8,0.3,2,2.1,2L484.7,337.3L484.7,337.3z M477.1,318.9v7.7h2.5
		v-7.7H477.1z M485.3,318.9h-2.5v7.7h2.5V318.9z"
        />
        <path
          fill="#E77452"
          d="M518.5,318.1v3.3h-15.6c-1,2-2.1,4-3.4,5.7v14.1H496v-10.1c-0.8,0.8-1.6,1.4-2.6,2c-0.4-0.9-1.2-2.5-1.7-3.4
		c3.1-2,5.5-5,7.3-8.4h-6.3v-3.3h7.9c0.5-1.4,0.9-2.7,1.3-4.1l3.6,0.9c-0.3,1.1-0.7,2.1-1.1,3.2H518.5z M511.5,337.4h6.9v3.2h-17.5
		v-3.2h7.1v-6.6h-5.9v-3.2h5.9v-4.8h3.5v4.8h5.8v3.2h-5.8L511.5,337.4L511.5,337.4z"
        />
        <path
          fill="#E77452"
          d="M548,328.3c-1.2,1.2-2.6,2.4-3.8,3.4c0.9,2.7,2.2,4.9,4,6.2c-0.8,0.6-1.8,2-2.3,2.9c-3.6-2.9-5.2-8.3-6.1-14.8
		c-0.6,0.1-1.3,0.3-1.9,0.4v9.8l3.6-1.4c0,1,0.2,2.4,0.4,3.1c-5.3,2.2-6.3,2.7-6.9,3.2c-0.3-0.7-1.2-1.9-1.7-2.4
		c0.6-0.5,1.3-1.5,1.3-3v-10.7l-0.1,0.1c-0.6-0.6-2-1.7-2.8-2.1c0.3-0.4,0.7-0.7,1-1.1h-5.5v2.8h5.3c0,0,0,1,0,1.4
		c-0.2,9.2-0.5,12.6-1.2,13.7c-0.5,0.8-1.1,1.1-1.9,1.2c-0.7,0.1-1.7,0.1-2.9,0.1c-0.1-0.9-0.4-2.2-0.8-3c0.8,0.1,1.6,0.1,2.1,0.1
		c0.4,0,0.6-0.1,0.8-0.4c0.4-0.6,0.6-3.1,0.8-9.9h-2.1c-0.2,4.3-1,9.3-4,13.5c-0.6-0.6-1.7-1.5-2.5-1.9c3.1-4.5,3.5-9.6,3.5-13.6v-4
		h-2.7v-3.2h5c-0.3-1.1-0.8-2.5-1.3-3.6l3-0.9c0.6,1.2,1.2,2.8,1.5,3.9l-2,0.7h5.2v3c1.5-2,2.7-4.7,3.3-7.5l3.3,0.6
		c-0.2,1-0.5,2-0.8,2.9h9.2v3.1h-10.5c-0.6,1.3-1.3,2.4-2.1,3.4c3.5-0.8,7.3-1.9,9.6-3l2.7,2.4c-1.4,0.6-3,1.1-4.7,1.6
		c0.1,1.2,0.3,2.3,0.6,3.4c0.8-0.8,1.7-1.7,2.2-2.4L548,328.3z"
        />
        <path
          fill="#E77452"
          d="M558.5,327.7c-0.6,2.7-1.4,5.4-2.4,7.5c0.5,0.3,1,0.7,1.8,1.2c2,1.2,4.7,1.4,8.1,1.4s8.5-0.3,11.7-0.8
		c-0.4,0.9-1,2.7-1,3.6c-2.4,0.1-7.5,0.3-10.8,0.3c-3.8,0-6.3-0.3-8.4-1.5c-1.3-0.7-2.2-1.6-2.9-1.6c-0.7,0-1.7,2-2.4,3.6l-2.3-3.3
		c1-1.2,2.1-2.2,3.1-2.8c0.7-1.4,1.3-3.3,1.8-5h-3.8c0.7-1.7,1.6-4.1,2.3-6.3h-2.8v-3.1h7.3l-0.2,0.6c3.3-1.8,7-4.7,9-7.7l2.9,1.3
		l-0.4,0.6c3,1.7,6.7,4.1,8.6,5.7l-2.1,2.7c-0.6-0.6-1.5-1.3-2.5-2v2H569v1.9h7.2v2.9H569v7.8h-3.5v-7.8H559v-2.9h6.5v-1.9h-3.2
		v-1.6c-1,0.7-2,1.4-3,2c-0.5-0.7-1.2-1.7-2-2.3c-0.6,1.7-1.3,3.6-1.9,5.3h1.1l0.5-0.1L558.5,327.7z M553.8,320
		c-0.4-1.3-1.2-3.4-1.7-5l3.2-0.9c0.6,1.6,1.4,3.5,1.9,4.8L553.8,320z M564.5,330.2c-1.1,1.9-2.8,4.2-4.1,5.5
		c-0.6-0.5-1.9-1.3-2.6-1.7c1.4-1.3,2.9-3.1,3.8-4.8L564.5,330.2z M572,321.1c-1.6-1.1-3.3-2.2-4.9-3.3c-1.1,1.2-2.2,2.2-3.4,3.3
		H572z M573,329.2c1.3,1.5,2.9,3.7,3.6,5.2l-2.9,1.4c-0.7-1.4-2.2-3.7-3.5-5.3L573,329.2z"
        />
        <path
          fill="#E77452"
          d="M605,319.1v14.5h-3.6v-1.5h-6.6v9.1h-3.7v-9.1h-6.6v1.6H581v-14.7h10.1v-5h3.7v5H605z M591.1,328.8v-6.3h-6.6
		v6.3H591.1z M601.3,328.8v-6.3h-6.6v6.3H601.3z"
        />
        <path
          fill="#E77452"
          d="M619.2,329.5c-1.1,0.3-2.2,0.6-3.4,0.9v6.9c0,1.7-0.3,2.5-1.3,3c-1,0.6-2.4,0.6-4.4,0.6
		c-0.1-0.9-0.6-2.3-1-3.1c1.2,0,2.4,0,2.7,0c0.4,0,0.6-0.1,0.6-0.6v-6l-3.1,0.8l-0.9-3.3c1.1-0.2,2.5-0.6,4-0.9v-5.1h-3.6v-3.2h3.6
		v-5.5h3.4v5.5h3.1v3.2h-3.1v4.3l3-0.7L619.2,329.5z M634.1,326.4c-1.2,2.7-3.1,5.4-5.2,7.8c0.8,1.6,1.7,2.6,2.9,2.8
		c0.7,0.1,1-1.3,1.3-4.5c0.7,0.8,2.2,1.7,2.9,2c-0.8,5.4-2.3,6.8-4,6.6c-2.5-0.3-4.4-1.7-5.8-4.3c-1.7,1.5-3.6,2.7-5.5,3.6
		c-0.6-0.9-1.8-2-2.8-2.7c2.5-1,4.8-2.4,6.9-4.3c-0.7-2.4-1.3-5.3-1.6-8.7l-3.6,0.4l-0.4-3.3l3.7-0.4c-0.2-2.2-0.3-4.7-0.4-7.2h3.6
		c0,2.4,0.1,4.7,0.3,6.9l8.7-0.8l0.3,3.2l-8.8,0.9c0.3,2.3,0.6,4.3,1,6.1c1.5-1.8,2.7-3.8,3.6-5.8L634.1,326.4z M630.9,320.5
		c-0.8-1.2-2.5-3.1-3.7-4.4l2.6-1.7c1.3,1.3,3.1,3.1,3.9,4.2L630.9,320.5z"
        />
        <path
          fill="#E77452"
          d="M663.7,315.1v26.2h-3.8v-1.5h-17.5v1.5h-3.6v-26.2H663.7z M659.9,336.5v-17.9h-17.5v17.9H659.9z M657.1,322
		v11.1h-11.9V322H657.1z M653.6,325.1h-5.1v5h5.1V325.1z"
        />
        <path
          fill="#E77452"
          d="M694.1,336.4h-5v4.8h-3.3v-4.8h-5.4v-3h5.4v-2.6h-2.4c-0.3,0.8-0.7,1.6-1.2,2.2c-0.5-0.4-1.5-0.9-2.3-1.2v6.1
		c0,1.4-0.2,2.2-1.1,2.7c-0.9,0.5-2.1,0.6-3.9,0.6c-0.1-0.8-0.6-2.2-1-2.9c1.2,0.1,2.3,0.1,2.7,0.1s0.5-0.1,0.5-0.5v-4.2h-5.8
		c-0.3,2.7-1,5.6-2.3,7.7c-0.5-0.5-1.7-1.3-2.4-1.5c2-3,2.1-7.3,2.1-10.6v-4.3c-0.6-0.6-1.7-1.5-2.3-1.9c2-2.1,3.5-5.5,4.3-8.9
		l3.1,0.6c-0.2,0.7-0.4,1.4-0.6,2.1h2.7l0.4-0.1l2,1.2c-0.4,1.1-1,2.5-1.6,3.7h3.3v1.8c2.4-1.1,3.3-2.8,3.7-4.9h-3.3v-2.8h12.9
		c0,0,0,0.7-0.1,1.1c-0.1,4.6-0.4,6.6-1,7.4c-0.5,0.6-1,0.8-1.8,1c-0.6,0.1-1.8,0.1-2.9,0.1c-0.1-0.9-0.4-2.1-0.8-2.8
		c0.9,0.1,1.7,0.1,2.1,0.1c0.3,0,0.6-0.1,0.8-0.3c0.3-0.3,0.4-1.3,0.5-3.7h-3.4c-0.5,3-1.6,5.5-4.6,7.1l2.6,0.5
		c-0.1,0.6-0.2,1.3-0.4,1.9h1.4v-2.6h3.3v2.6h4.4v2.9h-4.4v2.6h5V336.4z M672.3,319.4c-0.3,0.7-0.6,1.5-1,2.1h2.5
		c0.3-0.6,0.6-1.4,0.8-2.1H672.3z M671.5,329.2c0,0.6,0,1.3,0,1.9h1.7v-2.4h-1.7V329.2z M671.5,326.3h1.7v-2.2h-1.7V326.3z
		 M675.5,326.3h1.7v-2.2h-1.7V326.3z M677.1,331.1v-2.4h-1.7v2.4H677.1z M679.9,331.3c1-1.5,1.7-3.6,2-5.7c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.3-0.6-0.8-1.4-1.4-2L679.9,331.3L679.9,331.3z"
        />
        <path
          fill="#E77452"
          d="M168.7,377.1c-2,2.1-5.6,3.8-8.9,4.6c-0.5-0.8-1.4-2-2.1-2.6c3.2-0.5,6.7-1.6,8.4-3L168.7,377.1z M173,375.8
		v6.5h-3.4v-6.5h-11.2v-2.6h11.2v-1.4h-2.8l0.1,0.4l-2,0.6c0-0.3-0.1-0.6-0.1-0.9c-3.9,0.4-4.6,0.6-5.1,0.8
		c-0.1-0.5-0.5-1.7-0.8-2.4c0.5-0.1,1-0.6,1.6-1.3c0.3-0.3,0.8-0.8,1.3-1.6c-1.8,0.2-2.3,0.4-2.6,0.5c-0.1-0.5-0.6-1.7-0.9-2.4
		c0.4-0.1,0.8-0.4,1.1-0.9c0.3-0.5,1.5-2.2,2-4l2.5,0.9c-0.6,1.3-1.5,2.7-2.4,3.8l1.7-0.1c0.4-0.7,0.8-1.4,1.2-2.1l2.3,1.1v-2h2.6
		c0.3-0.8,0.5-1.7,0.6-2.4l3.4,0.6c-0.3,0.6-0.6,1.2-0.9,1.8h3.6v3.2c0.3-0.1,0.6-0.4,0.9-0.8c0.3-0.5,1.3-2.1,1.8-3.8h-3v-1.5h-4
		v-2.9h4V355h3.4v1.4h5v2.9h-5v1.4l2.2,0.7c-0.6,1.3-1.4,2.7-2.2,3.8l1.5-0.1c0.4-0.7,0.9-1.5,1.3-2.3l2.4,1.1
		c-0.9,1.5-2,2.9-3.1,4.3l2-0.6c0.6,1.4,1.1,3.2,1.3,4.5l-2.2,0.7c0-0.3-0.1-0.6-0.1-1c-4,0.5-4.8,0.7-5.2,0.9
		c-0.1-0.5-0.6-1.7-0.8-2.4c0.5-0.1,1.1-0.6,1.7-1.3c0.2-0.3,0.7-0.8,1.3-1.5c-1.6,0.2-2.1,0.3-2.4,0.5c-0.1-0.5-0.5-1.5-0.8-2.2
		v6.1h-3v1.4h11.2v2.6L173,375.8L173,375.8z M163.6,359.3h-5.3v-2.9h5.3V355h3.4v1.4h3.7v2.9h-3.7v1.4h-3.4V359.3z M164.3,369.8
		c-0.1-0.5-0.3-1-0.5-1.4c-0.5,0.5-0.9,1-1.4,1.5L164.3,369.8z M165.6,367.7c0.5,1.2,1,2.6,1.2,3.8v-7c-0.8,1.3-1.7,2.5-2.7,3.7
		L165.6,367.7z M173,364.5h-3.3v1.4h3.3V364.5z M169.6,369.5h3.3V368h-3.3V369.5z M176,375.8c2.7,0.9,6.6,2.4,8.6,3.5l-2.1,2.2
		c-1.9-1.1-5.6-2.8-8.4-3.8L176,375.8z M181.8,369.7c-0.1-0.5-0.4-1-0.5-1.5c-0.5,0.6-1,1.2-1.5,1.7L181.8,369.7z"
        />
        <path
          fill="#E77452"
          d="M191.7,372.1c-0.2,3.6-0.8,7.6-2.5,10.3c-0.6-0.6-2.1-1.8-2.8-2.2c1.9-3.4,2-8.2,2-12v-10.5h0
		c3.5-0.4,7.4-1.2,9.9-2.1l2.2,2.9c-2.5,0.8-5.7,1.4-8.7,1.7v2.1h7.5v9.7H191.7z M191.9,365.4v2.8v0.8h4.1v-3.6H191.9z M214,368.1
		h-2.7v14h-3.4v-14h-3c-0.1,4.6-1.1,10.6-5.2,14.3c-0.6-0.7-2-1.9-2.7-2.4c4-3.6,4.4-9,4.4-13.2v-9.1c3.6-0.5,7.5-1.3,10-2.3l2.2,3
		c-2.5,0.9-5.7,1.5-8.7,1.9v4.4h9.1L214,368.1L214,368.1z"
        />
        <path
          fill="#E77452"
          d="M231.1,371.8c-0.2,0.5-0.4,1-0.6,1.4H241v5.9c0,1.4-0.2,2.2-1.2,2.6c-0.9,0.5-2.1,0.5-3.7,0.5
		c-0.1-0.9-0.6-2-1-2.8c0.9,0,1.8,0,2.1,0c0.3,0,0.4-0.1,0.4-0.4v-3.2h-3.2v6.2h-3.1v-6.2h-3.1v6.2h-3.1v-6.2h-3v6.3h-3.3v-9h8.4
		c0.1-0.5,0.2-0.9,0.3-1.4h-10.9v-2.7h4l-0.8-2.3c1.8-0.2,4.3-0.6,7-1l0.1,2c-2.1,0.5-4.1,1-5.9,1.4h21.5v2.7L231.1,371.8
		L231.1,371.8z M220.1,366.6h-3.3v-6.5h11v-1.4h-9.7v-2.5H241v2.5h-9.8v1.4h11.2v6.5H239v-4h-1.6l1.1,1.5c-1.6,0.6-3.7,1.1-5.2,1.4
		l-1.1-1.7c1.2-0.2,2.9-0.8,4.1-1.3h-5.1v5.6h-3.4v-5.6H222c1.6,0.3,3.6,0.8,4.7,1.2l-0.9,1.9c-1.2-0.5-3.4-1.1-5-1.5l0.9-1.6h-1.6
		L220.1,366.6L220.1,366.6z M232.4,365.5c2.2,0.2,5.1,0.8,6.7,1.4l-0.6,2.2c-1.5-0.6-4.5-1.3-6.7-1.7L232.4,365.5z"
        />
        <path
          fill="#E77452"
          d="M266.2,374.4c-0.8,1.2-1.6,2.2-2.6,3.1c3.1,0.7,5.9,1.5,8.1,2.2l-3.1,2.4c-2.2-0.8-5-1.7-8.4-2.5
		c-3.3,1.5-7.7,2.3-13.4,2.7c-0.2-1-0.8-2.2-1.3-3c3.6-0.1,6.6-0.4,9.1-1c-1.9-0.4-3.8-0.8-5.7-1.1c0.7-0.8,1.5-1.7,2.2-2.8h-5.5
		v-2.9h7.4c0.6-0.9,1-1.8,1.5-2.7h-7.1v-8.2h6.3v-1.7H246v-3h25.4v3h-7.9v1.7h7v8.2h-15.6l3.1,0.7c-0.3,0.6-0.6,1.3-1,2h7
		c0.2-0.5,0.4-1.1,0.6-1.6l3.4,0.8c-0.1,0.3-0.2,0.6-0.3,0.8h4.4v2.9L266.2,374.4L266.2,374.4z M250.6,366.2h3.1v-2.7h-3.1V366.2z
		 M255,374.4c-0.3,0.4-0.6,0.8-0.8,1.1c1.7,0.3,3.5,0.7,5.2,1c1-0.6,1.9-1.3,2.6-2.2L255,374.4L255,374.4z M256.9,360.7h3.3v-1.7
		h-3.3V360.7z M260.2,366.2v-2.7h-3.3v2.7H260.2z M263.5,363.5v2.7h3.5v-2.7H263.5z"
        />
        <path
          fill="#E77452"
          d="M300.8,359.5c0,0,0,1.2,0,1.6c-0.4,13-0.7,17.7-1.9,19.2c-0.8,1.1-1.6,1.4-2.8,1.6c-1.1,0.1-2.9,0.1-4.6,0.1
		c-0.1-1-0.5-2.4-1.1-3.4c1.9,0.2,3.6,0.2,4.3,0.2c0.6,0,0.9-0.1,1.3-0.5c0.8-0.9,1.2-5.3,1.5-15.6h-6.2c-0.8,1.7-1.7,3.4-2.6,4.6
		c-0.5-0.4-1.5-1.1-2.2-1.6v13.6h-7.8v2.1h-3.1v-21.7h3.3c0.4-1.5,0.7-3.3,0.8-4.7l3.8,0.5c-0.5,1.5-1,2.9-1.5,4.2h4.5v4.7
		c1.7-2.4,3.1-6,3.9-9.4l3.3,0.8c-0.3,1.3-0.7,2.5-1.1,3.7L300.8,359.5L300.8,359.5z M283.3,362.8h-4.6v4.7h4.6V362.8z M283.3,376.2
		v-5.7h-4.6v5.7H283.3z M293,374.6c-0.8-1.7-2.6-4.6-4.1-6.7l2.7-1.5c1.5,2,3.4,4.8,4.3,6.5L293,374.6z"
        />
        <path
          fill="#E77452"
          d="M330.7,379v2.7h-17.6V379h7.4v-1.3h-5.8v-2.6h5.8v-1.3h-5.6v-2.6l-1.9,2.6c-0.4-0.8-1-1.9-1.7-2.9v11.4h-3.4
		v-10.5c-0.9,2.2-2,4.3-3.2,5.8c-0.3-1-1-2.4-1.6-3.3c1.6-1.9,3.2-5,4.3-7.8h-3.7v-3.2h4.2v-3.4c-1.2,0.2-2.4,0.4-3.6,0.6
		c-0.2-0.8-0.6-2-1-2.7c3.2-0.6,6.8-1.4,9-2.4l2.3,2.7c-1,0.4-2.2,0.8-3.5,1.1v4.1h3.1v3.2h-3.1v0.8c0.8,0.6,3,3,3.7,3.8V364h5.6
		v-1.2H314v-2.7h6.6v-1.2c-1.9,0.1-3.8,0.1-5.5,0.2c-0.1-0.8-0.4-1.9-0.8-2.6c4.8-0.1,10.4-0.5,13.8-1.2l2,2.6
		c-1.8,0.4-4,0.6-6.2,0.8v1.5h6.3v2.7h-6.3v1.2h5.8v9.8h-5.8v1.3h5.8v2.6h-5.8v1.3L330.7,379L330.7,379z M317.9,367.9h2.6v-1.4h-2.6
		V367.9z M320.5,371.4v-1.5h-2.6v1.5H320.5z M323.8,366.4v1.4h2.7v-1.4H323.8z M326.5,369.9h-2.7v1.5h2.7V369.9z"
        />
        <path
          fill="#E77452"
          d="M359.8,370.7h-5.9v7.8c0,1.8-0.4,2.7-1.6,3.2c-1.2,0.5-2.8,0.6-5.1,0.6c-0.2-1-0.7-2.4-1.1-3.3
		c1.4,0.1,3.1,0.1,3.6,0.1c0.5,0,0.7-0.1,0.7-0.6v-7.7h-5.9v-3.3h5.9v-3.9c1.2-0.9,2.3-2.2,3.3-3.4h-8.2v-2.3
		c-0.8,2.1-1.8,4.5-2.5,6.1l-2.2-0.7v1.6h3.6v3.2h-3.6v2.1l1.2-0.9c0.7,0.8,3.1,4.6,3.6,5.5l-2.4,2.6c-0.5-1.5-1.6-3.8-2.5-5.5v10.5
		h-3.2v-11.5c-0.6,3.1-1.7,6.8-3.4,8.7c-0.3-1.1-1-2.6-1.4-3.6c1.2-1.5,2.3-4.4,2.7-6.7l2.1,0.7v-2h-4.3v-3.2h4.3v-9.6h3.2v7.9
		c0.7-1.7,1.5-4.3,1.9-6.2l2.9,0.8v-0.7h10.8l0.8-0.2l2.3,1.7c-1.4,1.9-3.4,4.1-5.4,5.7v3.2h5.9V370.7z M334.6,364
		c-0.3-1.7-1-4.5-1.6-6.5l2.6-0.7c0.7,2,1.4,4.7,1.8,6.4L334.6,364z"
        />
        <path
          fill="#E77452"
          d="M382.6,368.4c-1.2,2.7-2.7,5-4.6,6.8c2.8,1.8,6.3,3.1,10.6,3.7c-0.8,0.8-1.7,2.2-2.1,3.1
		c-4.6-0.9-8.2-2.4-11.2-4.6c-3.1,2.2-6.8,3.7-11.1,4.7c-0.4-0.8-1.4-2.3-2.1-3.1c4.2-0.8,7.8-2.1,10.7-4c-1.7-1.9-3.1-4.1-4.3-6.7
		l3.1-1c0.9,2.1,2.1,4,3.7,5.6c1.7-1.6,2.9-3.5,3.8-5.7L382.6,368.4z M372.8,363.7c-2,2.6-5.1,5.2-7.7,6.8c-0.6-0.7-2-2-2.7-2.5
		c2.6-1.3,5.4-3.4,7.1-5.5L372.8,363.7z M388.1,362.1h-25.6v-3.4h11.4c-0.4-1-1-2-1.5-2.9l3.3-1.2c0.8,1.3,1.7,2.9,2.1,4l-0.1,0
		h10.3L388.1,362.1L388.1,362.1z M380.8,362.2c2.5,1.7,5.9,4.3,7.5,6.1l-3,2.2c-1.4-1.8-4.7-4.5-7.3-6.4L380.8,362.2z"
        />
        <path
          fill="#E77452"
          d="M399.8,373.2c-0.1-0.4-0.1-0.9-0.3-1.4c-5.9,0.9-6.9,1.1-7.6,1.5c-0.2-0.6-0.7-2.2-1.1-3.1
		c0.8-0.2,1.4-0.8,2.4-1.9c0.4-0.4,1-1.2,1.8-2.3c-2.2,0.3-2.9,0.4-3.3,0.6c-0.2-0.6-0.7-2.2-1-3c0.6-0.2,1.1-0.7,1.7-1.6
		c0.6-0.8,2.5-4.1,3.6-7.1l3.1,1.3c-1.1,2.4-2.6,5-4.1,7l2-0.1c0.7-1.2,1.5-2.5,2-3.8l2.9,1.8c-1.7,3-3.8,6-6.1,8.5l3.1-0.4
		c-0.2-0.8-0.5-1.5-0.7-2.2l2.5-0.8c0.8,2,1.5,4.6,1.9,6.1L399.8,373.2z M394.9,374.7c-0.2,2.7-0.7,5.6-1.3,7.5
		c-0.6-0.4-2-0.8-2.8-1c0.7-1.7,1-4.5,1.2-6.9L394.9,374.7z M398.1,374.1c0.4,2.1,0.7,4.7,0.8,6.5l-2.7,0.6c0-1.8-0.4-4.5-0.7-6.6
		L398.1,374.1z M401.1,373.2c0.6,1.7,1.3,4,1.6,5.5l-2.6,0.9c-0.2-1.5-0.9-3.8-1.5-5.5L401.1,373.2z M411.7,355.9
		c-0.1,0.4-0.3,0.7-0.4,1c1.8,2.9,4.8,5.9,7.5,7.6c-0.8,0.6-2,1.9-2.6,2.8c-0.6-0.5-1.3-1-1.9-1.6v1.8h-9.6v-1.4
		c-0.6,0.6-1.3,1.1-2,1.5c-0.5-0.7-1.6-1.9-2.4-2.5c3.7-2.3,6.7-6.3,8.2-10.2L411.7,355.9z M403.3,370h13.1v12.4h-3.5v-1.4h-6.2v1.4
		h-3.4L403.3,370L403.3,370z M413.1,364.4c-1.2-1.4-2.4-2.9-3.4-4.4c-1,1.6-2.1,3.1-3.3,4.4H413.1z M406.6,373v4.8h6.2V373H406.6z"
        />
        <path
          fill="#E77452"
          d="M444.3,376.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6H423v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C442.2,373.8,443.7,375.1,444.3,376.1L444.3,376.1z M431.4,369.8c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H431.4z M428.9,359.9
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H428.9z M441.2,365.5h-5.7c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V365.5z M442.7,379
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L442.7,379L442.7,379z"
        />
        <path
          fill="#E77452"
          d="M473.4,376.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6h-7.3v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C471.3,373.8,472.8,375.1,473.4,376.1L473.4,376.1z M460.5,369.8c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H460.5z M458.1,359.9
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H458.1z M470.4,365.5h-5.7c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V365.5z M471.9,379
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L471.9,379L471.9,379z"
        />
        <path
          fill="#E77452"
          d="M484.7,372.1c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7
		C480,374.3,482.1,372.1,484.7,372.1z M484.7,379.5c1.5,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6
		C482.1,378.3,483.3,379.5,484.7,379.5z"
        />
        <path
          fill="#E77452"
          d="M517.2,376.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6h-7.3v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C515,373.8,516.5,375.1,517.2,376.1L517.2,376.1z M504.2,369.8c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H504.2z M501.8,359.9
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H501.8z M514.1,365.5h-5.7c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V365.5z M515.6,379
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L515.6,379L515.6,379z"
        />
        <path
          fill="#E77452"
          d="M546.3,376.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6H525v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C544.2,373.8,545.7,375.1,546.3,376.1L546.3,376.1z M533.4,369.8c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H533.4z M530.9,359.9
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H530.9z M543.2,365.5h-5.7c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V365.5z M544.7,379
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L544.7,379L544.7,379z"
        />
        <path
          fill="#E77452"
          d="M572.2,374.4c-0.8,1.2-1.6,2.2-2.6,3.1c3.1,0.7,5.9,1.5,8.1,2.2l-3.1,2.4c-2.2-0.8-5-1.7-8.4-2.5
		c-3.3,1.5-7.7,2.3-13.4,2.7c-0.2-1-0.8-2.2-1.3-3c3.6-0.1,6.6-0.4,9.1-1c-1.9-0.4-3.8-0.8-5.7-1.1c0.7-0.8,1.5-1.7,2.2-2.8h-5.5
		v-2.9h7.4c0.6-0.9,1-1.8,1.5-2.7h-7.1v-8.2h6.3v-1.7H552v-3h25.4v3h-7.9v1.7h7v8.2h-15.6l3.1,0.7c-0.3,0.6-0.6,1.3-1,2h7
		c0.2-0.5,0.4-1.1,0.6-1.6l3.4,0.8c-0.1,0.3-0.2,0.6-0.3,0.8h4.4v2.9L572.2,374.4L572.2,374.4z M556.6,366.2h3.1v-2.7h-3.1V366.2z
		 M561,374.4c-0.3,0.4-0.6,0.8-0.8,1.1c1.7,0.3,3.5,0.7,5.2,1c1-0.6,1.9-1.3,2.6-2.2L561,374.4L561,374.4z M562.9,360.7h3.3v-1.7
		h-3.3V360.7z M566.2,366.2v-2.7h-3.3v2.7H566.2z M569.5,363.5v2.7h3.5v-2.7H569.5z"
        />
        <path
          fill="#E77452"
          d="M582,358.2h13.2v3.6h-8.9v5h7.6v3.6h-7.6v5.8h9.2v3.6H582V358.2z"
        />
        <path
          fill="#E77452"
          d="M598.7,375.3c0-3.5,2.8-5.3,9.4-6c-0.1-1.6-0.8-2.8-2.8-2.8c-1.5,0-3,0.7-4.5,1.5l-1.5-2.8
		c1.9-1.2,4.3-2.2,6.8-2.2c4.1,0,6.3,2.5,6.3,7.2v9.5h-3.5l-0.3-1.7h-0.1c-1.4,1.2-3.1,2.2-4.9,2.2
		C600.7,380.2,598.7,378.1,598.7,375.3z M608.1,375.2v-3.3c-4,0.5-5.3,1.6-5.3,3.1c0,1.3,0.9,1.8,2.2,1.8
		C606.2,376.8,607.1,376.2,608.1,375.2z"
        />
        <path
          fill="#E77452"
          d="M615.2,377.9l2-2.7c1.5,1.1,2.9,1.8,4.4,1.8c1.6,0,2.4-0.7,2.4-1.7c0-1.2-1.7-1.8-3.4-2.4
		c-2.1-0.8-4.5-2-4.5-4.8c0-2.9,2.4-5,6.1-5c2.4,0,4.2,1,5.6,2l-1.9,2.6c-1.2-0.8-2.3-1.4-3.5-1.4c-1.5,0-2.2,0.6-2.2,1.6
		c0,1.2,1.6,1.6,3.3,2.3c2.2,0.8,4.5,1.9,4.5,4.9c0,2.9-2.2,5.2-6.5,5.2C619.2,380.2,616.8,379.2,615.2,377.9z"
        />
        <path
          fill="#E77452"
          d="M630.2,371.6c0-5.5,3.8-8.6,7.8-8.6s7.8,3.1,7.8,8.6c0,5.4-3.8,8.5-7.8,8.5S630.2,377,630.2,371.6z
		 M641.5,371.6c0-3.1-1.3-5.1-3.5-5.1s-3.5,2-3.5,5.1c0,3.1,1.3,5,3.5,5S641.5,374.7,641.5,371.6z"
        />
        <path
          fill="#E77452"
          d="M649.4,363.4h3.5l0.3,2.2h0.1c1.4-1.4,3.1-2.6,5.3-2.6c3.5,0,5,2.4,5,6.6v10.2h-4.3v-9.6
		c0-2.5-0.7-3.4-2.3-3.4c-1.3,0-2.2,0.6-3.4,1.8v11.2h-4.3L649.4,363.4L649.4,363.4z"
        />
        <path
          fill="#E77452"
          d="M676.8,370.7c-1.1,0.3-2.2,0.6-3.3,0.9v7c0,1.6-0.3,2.4-1.2,3c-0.9,0.5-2.2,0.6-4,0.6c-0.1-0.9-0.5-2.3-1-3.2
		c0.9,0.1,1.9,0.1,2.2,0c0.3,0,0.5-0.1,0.5-0.5v-6.2c-1,0.3-1.9,0.5-2.8,0.7l-0.8-3.3c1-0.2,2.3-0.5,3.6-0.8v-5.3H667v-3.2h3.1v-5.5
		h3.4v5.5h2.7v3.2h-2.7v4.4l2.8-0.7L676.8,370.7z M688.8,378.3c1.6,0,1.9-0.8,2.2-4c0.8,0.6,2.3,1.2,3.4,1.4c-0.5,4.4-1.6,6-5.2,6
		h-6.3c-4,0-5.3-1.1-5.3-5.4v-19.8h15.5v16.3h-3.6v-1.8h-8.2v5.4c0,1.8,0.3,2,2.1,2L688.8,378.3L688.8,378.3z M681.1,359.8v7.7h2.5
		v-7.7H681.1z M689.3,359.8h-2.5v7.7h2.5V359.8z"
        />
        <path
          fill="#E77452"
          d="M185,420v2.7h-17.6V420h7.4v-1.3H169v-2.6h5.8v-1.3h-5.6v-2.6l-1.9,2.6c-0.4-0.8-1-1.9-1.7-2.9v11.4h-3.4
		v-10.5c-0.9,2.2-2,4.3-3.2,5.8c-0.3-1-1.1-2.4-1.6-3.3c1.6-1.9,3.2-5,4.3-7.8H158v-3.2h4.2v-3.4c-1.2,0.2-2.4,0.4-3.6,0.6
		c-0.2-0.8-0.6-2-1-2.7c3.2-0.6,6.8-1.4,9-2.4l2.3,2.7c-1,0.4-2.2,0.8-3.5,1.1v4.1h3.1v3.2h-3.1v0.8c0.8,0.6,3,3,3.7,3.8V405h5.6
		v-1.2h-6.6v-2.7h6.6v-1.2c-1.9,0.1-3.8,0.1-5.5,0.2c-0.1-0.8-0.4-1.9-0.8-2.6c4.8-0.1,10.4-0.5,13.8-1.2l2,2.6
		c-1.8,0.4-4,0.6-6.2,0.8v1.5h6.3v2.7h-6.3v1.2h5.8v9.8h-5.8v1.3h5.8v2.6h-5.8v1.3L185,420L185,420z M172.2,408.8h2.6v-1.4h-2.6
		V408.8z M174.8,412.4v-1.5h-2.6v1.5H174.8z M178.1,407.4v1.4h2.7v-1.4H178.1z M180.8,410.9h-2.7v1.5h2.7V410.9z"
        />
        <path
          fill="#E77452"
          d="M214,411.6h-5.9v7.8c0,1.8-0.4,2.7-1.6,3.2c-1.2,0.5-2.8,0.6-5.1,0.6c-0.2-1-0.7-2.4-1.1-3.3
		c1.4,0.1,3.1,0.1,3.6,0.1c0.5,0,0.7-0.1,0.7-0.6v-7.7h-5.9v-3.3h5.9v-3.9c1.2-0.9,2.3-2.2,3.3-3.4h-8.2v-2.3
		c-0.8,2.1-1.8,4.5-2.5,6.1l-2.2-0.7v1.6h3.6v3.2h-3.6v2.1l1.2-0.9c0.7,0.8,3.1,4.6,3.6,5.5l-2.4,2.6c-0.5-1.5-1.6-3.8-2.5-5.5v10.5
		h-3.2v-11.5c-0.6,3.1-1.7,6.8-3.4,8.7c-0.3-1.1-1-2.6-1.4-3.6c1.2-1.5,2.3-4.4,2.7-6.7l2.1,0.7v-2h-4.3v-3.2h4.3V396h3.2v7.9
		c0.7-1.7,1.5-4.3,1.9-6.2l2.9,0.8v-0.7h10.8l0.8-0.2l2.3,1.7c-1.4,1.9-3.4,4.1-5.4,5.7v3.2h5.9V411.6z M188.9,405
		c-0.3-1.7-1-4.5-1.6-6.5l2.6-0.7c0.7,2,1.4,4.7,1.8,6.4L188.9,405z"
        />
        <path
          fill="#E77452"
          d="M226,414.4c-3,1.5-6.3,3.1-8.9,4.3l-1.4-3.5c1-0.3,2.2-0.8,3.6-1.3V406h-3.2v-3.3h3.2v-6.3h3.2v6.3h3.1v3.3
		h-3.1v6.4l2.7-1.1L226,414.4z M243.2,419.2v3.2h-18.8v-3.2h7.9v-2.8h-5.9v-3.1h5.9v-2.5h-5.7v-13.6h15.3v13.6H236v2.5h6.2v3.1H236
		v2.8H243.2z M229.7,402.7h2.9v-2.4h-2.9V402.7z M229.7,407.9h2.9v-2.5h-2.9V407.9z M238.5,400.2h-2.9v2.4h2.9V400.2z M238.5,405.4
		h-2.9v2.5h2.9V405.4z"
        />
        <path
          fill="#E77452"
          d="M253.3,409.6c-0.5,2.7-1.3,5.4-2.3,7.6c0.5,0.3,1,0.7,1.8,1.2c2,1.2,4.7,1.4,8.1,1.4c3.4,0,8.6-0.3,11.8-0.8
		c-0.4,0.9-1,2.6-1,3.6c-2.4,0.1-7.5,0.4-11,0.4c-3.9,0-6.3-0.3-8.4-1.5c-1.2-0.7-2.2-1.6-2.9-1.6c-0.7,0-1.7,2-2.4,3.6l-2.3-3.3
		c1-1.2,2.1-2.2,3.1-2.8c0.6-1.5,1.2-3.3,1.7-5.1h-3.7c0.7-1.7,1.5-4.1,2.1-6.3h-2.6v-3.1h6.8c-0.6,2-1.3,4.4-2,6.4h1.2l0.5-0.1
		L253.3,409.6z M248.4,402c-0.3-1.3-1.1-3.4-1.6-5l3.1-0.9c0.6,1.6,1.3,3.5,1.7,4.8L248.4,402z M255.1,406.5c-0.5,0.6-1,1.1-1.5,1.6
		c-0.3-0.7-1.3-2.4-1.9-3.2c2.3-2.1,4.4-5.4,5.6-8.8l3.1,0.9c-0.4,1.3-1,2.5-1.6,3.7h4.3c-0.4-1-0.9-2.2-1.4-3.1l3.3-0.9
		c0.7,1.3,1.5,2.9,1.9,4.1h4.6v2.9h-5.9v1.7h4.7v2.8h-4.7v1.8h4.6v2.8h-4.6v1.8h6.2v2.9h-13.5v1.2h-3.4L255.1,406.5L255.1,406.5z
		 M262.4,403.6h-4v1.7h4V403.6z M262.4,408h-4v1.8h4V408z M262.4,412.6h-4v1.8h4V412.6z"
        />
        <path
          fill="#E77452"
          d="M301.1,418.6v3.4h-26.4v-3.4H286v-10.1h-9.4V405h9.4v-8.9h3.7v8.9h9.5v3.4h-9.5v10.1H301.1z"
        />
        <path
          fill="#E77452"
          d="M330.1,418.6v3.6H304v-3.6h8.2v-14h-7.7v-3.4h5.9c-0.5-1.2-1.3-2.8-2.1-3.9l3.1-1.2c1.1,1.5,2.1,3.4,2.6,4.7
		l-1.1,0.5h7.1c1-1.5,2-3.6,2.7-5.2l3.9,1c-0.9,1.5-1.8,3-2.6,4.2h5.6v3.4h-7.7v14L330.1,418.6L330.1,418.6z M308.8,406.8
		c1.3,2.8,2.3,6.4,2.6,8.9l-3.4,0.8c-0.2-2.4-1.2-6.1-2.3-8.9L308.8,406.8z M315.6,418.6h2.8v-14h-2.8V418.6z M322.3,415.7
		c1-2.4,2.2-6.2,2.7-9.1l3.8,0.8c-1,3.2-2.2,6.8-3.3,9.1L322.3,415.7z"
        />
        <path
          fill="#E77452"
          d="M336.9,409.5c-1-0.9-3.1-2.2-4.7-2.9l1.9-2.5c1.7,0.6,3.8,1.7,4.8,2.7L336.9,409.5z M339.7,413.6
		c-1.1,3.1-2.5,6.5-3.8,9.4l-3.1-1.9c1.2-2.3,2.9-5.9,4.1-9.4L339.7,413.6z M338.3,401.8c-1-1-3-2.3-4.7-3.1l2-2.6
		c1.6,0.7,3.7,1.9,4.8,2.8L338.3,401.8z M356.1,420.1c0.6,0,0.7-0.3,0.8-2.5c0.6,0.5,2,1,2.9,1.2c-0.3,3.3-1.1,4.1-3.3,4.1H354
		c-2.9,0-3.5-0.9-3.5-3.6v-2.8h-2.4c-0.6,3.4-2.1,5.5-7.5,6.8c-0.3-0.8-1.1-2.1-1.8-2.8c4.2-0.7,5.4-2,5.9-4h-4.5v-2.9h19.4v2.9
		h-5.7v2.7c0,0.8,0.1,0.8,0.7,0.8H356.1z M343.4,408.8h-2.8v-2.4h2.8v-1.7h-2.8v-2.7h7.3v-1.4h-5.8v-2.7h5.8v-2h3.4v2h6.3v2.7h-6.3
		v1.4h7.8v2.7h-3.3v1.7h3v2.4h-3v1.4h3.6v2.4h-9.9v-2.4h3.2v-1.4h-2.7v-2.4h2.7v-1.7h-6.4v1.7h2.6v2.4h-2.6v1.3l2.7-0.2v2.4
		c-3.1,0.3-6.4,0.6-8.9,0.8l-0.3-2.5c1-0.1,2.2-0.1,3.5-0.2L343.4,408.8L343.4,408.8z"
        />
        <path
          fill="#E77452"
          d="M372.5,403.9c-1.3,7.9-4.4,13.8-8.5,16.8c-0.6-0.8-2-2.2-2.8-2.7c3.4-2.3,5.9-6.3,7.1-11.4h-6.1v-3.5h7.3
		l0.6-0.1L372.5,403.9z M386.9,403.4c-2.2,2.2-4.7,4.6-6.8,6.2c2.2,3.4,5.2,6.1,8.9,7.7c-0.8,0.8-2,2.2-2.6,3.2
		c-4.1-2.2-7.2-5.7-9.5-10.1v8.4c0,2-0.4,3-1.5,3.7c-1.1,0.6-2.9,0.8-5.2,0.8c-0.1-1.1-0.8-2.8-1.3-3.9c1.6,0.1,3.1,0.1,3.7,0.1
		c0.5,0,0.7-0.2,0.7-0.7V396h3.7v7.1c0.5,1.3,1,2.5,1.6,3.8c1.8-1.7,3.8-4,5.2-5.8L386.9,403.4z"
        />
        <path
          fill="#E77452"
          d="M393.2,421.8c2.3-0.7,3.6-2,3.8-3.5c-0.1,0-0.2,0-0.3,0c-1.5,0-2.8-0.9-2.8-2.6c0-1.6,1.3-2.6,2.9-2.6
		c2.1,0,3.1,1.5,3.1,4c0,3.3-2.1,6-5.7,7.1L393.2,421.8z"
        />
        <path
          fill="#E77452"
          d="M413.4,411.6c-0.9,0.3-1.8,0.6-2.7,0.8v7.1c0,1.6-0.3,2.4-1.2,3c-0.8,0.6-2.1,0.7-4,0.6
		c-0.1-0.8-0.5-2.3-0.9-3.2c1,0.1,2,0.1,2.4,0c0.4,0,0.5-0.1,0.5-0.5v-6.1l-2.8,0.8l-0.8-3.3c1-0.2,2.2-0.6,3.5-0.9v-5.1h-3.1v-3.2
		h3.1v-5.5h3.2v5.5h2.6v3.2h-2.6v4.3l2.2-0.6L413.4,411.6z M428.5,413.8c-0.6,1.7-1.4,3.1-2.4,4.3c1.9,0.8,3.7,1.7,5,2.5l-2.2,2.5
		c-1.3-0.9-3.2-1.9-5.4-2.9c-2.2,1.4-5.1,2.3-8.9,2.9c-0.2-1-0.9-2.2-1.5-2.9c2.7-0.3,4.9-0.8,6.7-1.6c-1.7-0.7-3.4-1.3-4.9-1.8
		c0.7-0.9,1.4-2,2.2-3.1h-3.4v-2.9h5.1c0.5-0.9,0.9-1.8,1.2-2.6h-6v-2.9h4.2c-0.3-0.9-0.9-2.1-1.5-3l2.2-0.8h-4.2v-2.9h6.4
		c-0.3-0.7-0.6-1.5-0.9-2.1l3.8-0.7c0.5,0.8,1,1.8,1.4,2.7h5.3v2.9h-4.7l2.7,0.8c-0.6,1-1.2,2.1-1.7,3h4.3v2.9h-10.5l2.7,0.6
		c-0.3,0.7-0.6,1.4-1,2.1h3.6c0.1-0.6,0.3-1.1,0.4-1.7l3.3,0.5c0,0.4-0.1,0.8-0.2,1.2h2.2v2.9L428.5,413.8L428.5,413.8z
		 M419.7,401.5c0.7,0.9,1.3,2.2,1.6,3l-2.1,0.8h4.4c0.6-1,1.2-2.6,1.6-3.8H419.7z M420.6,413.8c-0.4,0.6-0.8,1.2-1.1,1.7
		c1.1,0.4,2.2,0.8,3.3,1.2c0.8-0.8,1.5-1.8,2-3H420.6z"
        />
        <path
          fill="#E77452"
          d="M450,410.6c-1.1,0.6-2.2,1-3.4,1.5h10.8v11h-3.6v-0.8h-11.1v0.8h-3.4v-8.5c-1.6,0.5-3.2,0.9-4.8,1.3
		c-0.3-0.7-1-2.1-1.5-2.7c3.3-0.6,6.6-1.5,9.8-2.6h-8.9v-3h9.4V406h-7v-2.8h7v-1.6h3.4v1.6h6.4v2.4c1.5-1,2.7-2,3.8-3.2l2.6,1.6
		c-1.3,1.3-2.7,2.5-4.3,3.6h4.8v3H450z M439.1,400.6h-5.3v-3h5.3V396h3.4v1.6h3.7v3h-3.7v1.8h-3.4V400.6z M453.8,414.8h-11.1v1.4
		h11.1V414.8z M453.8,419.8v-1.5h-11.1v1.5H453.8z M446.6,407.7h3c1-0.5,1.9-1.1,2.8-1.7h-5.9V407.7z M451.2,400.6h-3.9v-3h3.9V396
		h3.4v1.6h5v3h-5v1.8h-3.4V400.6z"
        />
        <path
          fill="#E77452"
          d="M486.6,417.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6h-7.3v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C484.5,414.8,486,416.1,486.6,417.1L486.6,417.1z M473.7,410.7c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H473.7z M471.2,400.8
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H471.2z M483.5,406.5h-5.7c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V406.5z M485,420
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L485,420L485,420z"
        />
        <path
          fill="#E77452"
          d="M515.7,417.1c0.8,0.5,2.1,1,2.9,1.2c-0.4,3.8-1.4,4.8-4.2,4.8h-4.5c-3.7,0-4.6-1-4.6-4.1v-4.6
		c-1.7,4-5,7.1-12,9c-0.3-0.9-1.2-2.2-1.9-2.9c5.9-1.4,8.8-3.7,10.3-6.6h-7.3v-6.8c-0.4,0.3-0.7,0.5-1,0.8c-0.5-0.8-1.6-2-2.4-2.6
		c4.1-2.6,6.8-6.1,8.3-9.2l3.7,0.7c-0.2,0.4-0.5,0.9-0.8,1.3h5.8l0.6-0.1l2.4,1.6c-0.7,1.3-1.7,2.7-2.8,4.1h8.1v10.3h-3.9
		C513.6,414.8,515.1,416.1,515.7,417.1L515.7,417.1z M502.8,410.7c0.3-1.3,0.5-2.7,0.6-4.3h-5.5v4.3H502.8z M500.3,400.8
		c-0.7,0.9-1.3,1.7-2.1,2.6h5.9c0.6-0.8,1.3-1.7,1.9-2.6H500.3z M512.7,406.5H507c-0.1,1.5-0.3,2.9-0.6,4.3h6.2V406.5z M514.2,420
		c1,0,1.3-0.4,1.4-2.8l-2.2,1.9c-0.7-1-2.4-2.7-3.7-3.8l1.9-1.5h-2.8v5.2c0,0.9,0.2,1.1,1.5,1.1L514.2,420L514.2,420z"
        />
        <path
          fill="#E77452"
          d="M528.4,403.8c-1.8,1-3.8,1.8-5.9,2.5c-0.4-0.8-1.4-2.2-2.1-2.8c5.6-1.5,10.4-4.3,12.7-7.9l3.1,1.2
		c-0.1,0.2-0.3,0.4-0.4,0.6c2.9,2.4,7.8,4.7,12.1,5.9c-0.8,0.7-1.8,2.1-2.4,3c-1.9-0.7-4-1.7-6-2.7v1.7h-11.1L528.4,403.8
		L528.4,403.8z M520.7,420.8c1-2,2.1-5,2.7-7.4l3.1,1.2c-0.7,2.3-1.6,5.5-2.5,7.7L520.7,420.8z M543.2,408c-1.1,2-3.1,4.6-4.7,6.2
		c-0.7-0.5-1.8-1.3-2.7-1.6c0.8-0.8,1.7-1.9,2.4-3h-13.7v-2.9h15.8l0.5-0.1L543.2,408z M543.9,412.5c1.3,2.5,3,5.9,3.8,8l-3.4,1.3
		c-0.3-1-0.9-2.4-1.5-3.8c-0.5,3.9-1.5,4.9-4.8,4.9h-5.6c-4.1,0-5.1-1-5.1-4.1v-5h3.5v5c0,0.9,0.3,1,2,1h5c1.4,0,1.6-0.4,1.8-3.4
		c0.7,0.5,2,1,3,1.2c-0.6-1.4-1.3-2.8-1.8-4.1L543.9,412.5z M533.2,411c1.4,1.7,3.4,4.1,4.4,5.5l-3,1.7c-0.9-1.5-2.8-3.9-4.2-5.7
		L533.2,411z M537.7,402.5c-1.4-0.9-2.7-1.8-3.9-2.8c-1,1-2.1,2-3.4,2.8H537.7z"
        />
        <path
          fill="#E77452"
          d="M575,399.9c-2.7,2.9-6.4,5.9-10,8.1v11.2c0,2-0.5,2.9-1.9,3.4c-1.5,0.5-3.5,0.6-6.3,0.6
		c-0.2-1-0.8-2.6-1.4-3.5c2.1,0.1,4.5,0.1,5.1,0.1c0.6,0,0.9-0.2,0.9-0.7v-12.9c2.3-1.2,4.8-3.1,6.7-4.8h-16.8v-3.4h20.2l0.8-0.2
		L575,399.9z"
        />
        <path fill="#E77452" d="M600.4,407.5v3.8h-26.8v-3.8H600.4z" />
        <path
          fill="#E77452"
          d="M614.7,416.8c-2.1,0.4-4.3,0.7-6.4,1.1v4.7h-3.3v-4.2l-1.8,0.3l-0.5-3.3c0.7-0.1,1.5-0.2,2.3-0.3v-16.4l0.1,0
		l0,0c2.7-0.8,5.8-2.1,7.7-3.1l2.7,2.7c-2.2,0.9-4.8,1.8-7.2,2.5v2h5.9v3h-5.9v2.9h5.8v3h-5.8v3c2-0.3,4.1-0.6,6.2-0.9L614.7,416.8z
		 M628.5,409.7c-0.8,3.5-2.2,6.3-4.1,8.4c1.6,1,3.5,1.8,5.8,2.2c-0.7,0.7-1.7,2.1-2.2,3c-2.4-0.7-4.4-1.6-6.2-3
		c-1.9,1.4-4.2,2.4-6.8,3.1c-0.3-0.9-1.1-2.2-1.7-3c2.3-0.5,4.4-1.3,6.1-2.4c-1.3-1.6-2.4-3.4-3.2-5.5l1.8-0.4h-2.8v-2.9h1
		c-0.6-0.6-1.7-1.7-2.3-2.1c2.8-1.7,3.1-4.2,3.1-6.3v-3.6h3.2v0h2.9v0h3.2v6.8c0,0.8,0.1,1.1,0.4,1.1h1.3c0.4,0,1.1-0.1,1.5-0.2
		c0.1,0.8,0.1,1.9,0.3,2.7c-0.4,0.2-1.1,0.2-1.7,0.2h-1.7c-2.7,0-3.3-1.1-3.3-3.8v-3.8h-2.9v0.7c0,2.7-0.6,6.1-3.7,8.2h9.2l0.6-0.1
		L628.5,409.7z M619.1,412c0.6,1.5,1.5,2.8,2.7,4c1.1-1.1,2-2.5,2.6-4H619.1z"
        />
        <path
          fill="#E77452"
          d="M654.8,419.6c0.7,0,0.8-0.7,0.9-4.6c0.7,0.6,2.2,1.2,3.1,1.4c-0.3,4.9-1.2,6.4-3.8,6.4h-2.7
		c-2.8,0-3.7-1-3.7-4.3v-5.9h-7.3v0.9c0,3.6-1.4,7.7-7.7,9.9c-0.3-0.8-1.4-2.4-2-3c5.6-1.8,6.2-4.4,6.2-7v-4h14.4v9.1
		c0,1,0.1,1.2,0.7,1.2L654.8,419.6L654.8,419.6z M644,406.9h-10.1v-9.2H644V406.9z M640.7,400.7H637v3.2h3.6V400.7z M656.8,406.8
		h-10.3v-9.2h10.3V406.8z M653.4,400.7h-3.8v3.1h3.8V400.7z"
        />
        <path
          fill="#E77452"
          d="M672.1,403.6h-11.2v-2.7h5c-0.4-1.1-1.2-2.6-1.9-3.7l2.7-1.3c0.8,1.2,1.7,2.8,2.2,3.9l-2,1h5.2L672.1,403.6
		L672.1,403.6z M671.3,421.7H665v1.2h-2.9v-10.1h9.2L671.3,421.7L671.3,421.7z M671.1,407.5h-8.9v-2.6h8.9V407.5z M662.1,408.8h8.9
		v2.6h-8.9V408.8z M665,415.6v3.3h3.3v-3.3H665z M688,408.1v2.9h-16.4v-2.9h3.5c0.2-1,0.4-2,0.6-3.2h-2.6v-2.8h3.1
		c0.1-0.7,0.2-1.5,0.3-2.2h-4.2v-2.9h15v2.9h-7.4c-0.1,0.7-0.2,1.4-0.4,2.2h6v6H688z M673.1,412.4h13.4v10.8h-3.4v-1h-6.8v1h-3.2
		L673.1,412.4L673.1,412.4z M676.3,415.3v3.9h6.8v-3.9H676.3z M679,404.9c-0.2,1.2-0.4,2.2-0.6,3.2h4v-3.2H679z"
        />
        <path
          fill="#E77452"
          d="M693.6,421.8c2.3-0.7,3.6-2,3.8-3.5c-0.1,0-0.2,0-0.3,0c-1.5,0-2.8-0.9-2.8-2.6c0-1.6,1.3-2.6,2.9-2.6
		c2.1,0,3.1,1.5,3.1,4c0,3.3-2.1,6-5.7,7.1L693.6,421.8z"
        />
        <path
          fill="#E77452"
          d="M185,461v2.7h-17.6V461h7.4v-1.3H169v-2.6h5.8v-1.3h-5.6v-2.6l-1.9,2.6c-0.4-0.8-1-1.9-1.7-2.9v11.4h-3.4
		v-10.5c-0.9,2.2-2,4.3-3.2,5.8c-0.3-1-1.1-2.4-1.6-3.3c1.6-1.9,3.2-5,4.3-7.8H158v-3.2h4.2v-3.4c-1.2,0.2-2.4,0.4-3.6,0.6
		c-0.2-0.8-0.6-2-1-2.7c3.2-0.6,6.8-1.4,9-2.4l2.3,2.7c-1,0.4-2.2,0.8-3.5,1.1v4.1h3.1v3.2h-3.1v0.8c0.8,0.6,3,3,3.7,3.8V446h5.6
		v-1.2h-6.6v-2.7h6.6v-1.2c-1.9,0.1-3.8,0.1-5.5,0.2c-0.1-0.8-0.4-1.9-0.8-2.6c4.8-0.1,10.4-0.5,13.8-1.2l2,2.6
		c-1.8,0.4-4,0.6-6.2,0.8v1.5h6.3v2.7h-6.3v1.2h5.8v9.8h-5.8v1.3h5.8v2.6h-5.8v1.3L185,461L185,461z M172.2,449.8h2.6v-1.4h-2.6
		V449.8z M174.8,453.3v-1.5h-2.6v1.5H174.8z M178.1,448.4v1.4h2.7v-1.4H178.1z M180.8,451.8h-2.7v1.5h2.7V451.8z"
        />
        <path
          fill="#E77452"
          d="M214,452.6h-5.9v7.8c0,1.8-0.4,2.7-1.6,3.2c-1.2,0.5-2.8,0.6-5.1,0.6c-0.2-1-0.7-2.4-1.1-3.3
		c1.4,0.1,3.1,0.1,3.6,0.1c0.5,0,0.7-0.1,0.7-0.6v-7.7h-5.9v-3.3h5.9v-3.9c1.2-0.9,2.3-2.2,3.3-3.4h-8.2v-2.3
		c-0.8,2.1-1.8,4.5-2.5,6.1l-2.2-0.7v1.6h3.6v3.2h-3.6v2.1l1.2-0.9c0.7,0.8,3.1,4.6,3.6,5.5l-2.4,2.6c-0.5-1.5-1.6-3.8-2.5-5.5v10.5
		h-3.2v-11.5c-0.6,3.1-1.7,6.8-3.4,8.7c-0.3-1.1-1-2.6-1.4-3.6c1.2-1.5,2.3-4.4,2.7-6.7l2.1,0.7v-2h-4.3v-3.2h4.3V437h3.2v7.9
		c0.7-1.7,1.5-4.3,1.9-6.2l2.9,0.8v-0.7h10.8l0.8-0.2l2.3,1.7c-1.4,1.9-3.4,4.1-5.4,5.7v3.2h5.9V452.6z M188.9,446
		c-0.3-1.7-1-4.5-1.6-6.5l2.6-0.7c0.7,2,1.4,4.7,1.8,6.4L188.9,446z"
        />
        <path
          fill="#E77452"
          d="M242.8,459.6v3.5h-26.4v-3.5h14.3c1.5-3.6,3-8.9,3.8-13l3.9,0.8c-1.1,4.2-2.6,8.8-3.9,12.2H242.8z
		 M241.6,445.7h-23.9v-3.5h10.6c-0.3-1.3-0.9-3.2-1.4-4.7l3.5-0.9c0.6,1.5,1.3,3.4,1.6,4.6l-3.1,0.9h12.8L241.6,445.7L241.6,445.7z
		 M223.7,458.9c-0.4-3.1-1.4-7.9-2.4-11.5l3.5-0.8c1.1,3.7,2.2,8.3,2.7,11.4L223.7,458.9z"
        />
        <path
          fill="#E77452"
          d="M261.9,451.1c-1.2,2-2.6,4-4.3,5.7c1.6,1.3,3.6,3,4.6,4.1l-2.4,2.2c-1-1.1-2.8-2.8-4.4-4.3
		c-2.5,2.2-5.2,3.9-8.1,5.3c-0.4-0.8-1.4-2.3-2.1-3c5.6-2.3,10.7-6.4,13.5-11.4L261.9,451.1z M260,445.5c-2.7,5.5-7.2,9.9-12.3,12.6
		c-0.4-0.7-1.4-2.2-2-2.9c2.7-1.2,5.2-2.9,7.3-5c-4.4,0.3-5.4,0.5-6,0.8c-0.2-0.7-0.7-2.2-1-3.1c0.6-0.1,1.1-0.6,1.8-1.2
		c0.5-0.4,1.5-1.6,2.6-3h-4.8v-3.2h6.9c-0.3-0.9-0.8-2-1.3-2.9l3.3-0.8c0.7,1.1,1.4,2.5,1.7,3.6h5.7v3.2h-7.5
		c-1,1.4-2.2,2.7-3.5,3.9l4.6-0.2c0.6-0.9,1.1-1.8,1.5-2.7L260,445.5z M266.3,456.5H263v-16.4h3.3V456.5z M271.6,437.3v22.8
		c0,1.9-0.4,2.8-1.5,3.3c-1.1,0.6-2.9,0.6-5.4,0.6c-0.1-0.9-0.6-2.4-1.1-3.3c1.6,0.1,3.4,0.1,3.9,0c0.5,0,0.7-0.2,0.7-0.7v-22.8
		L271.6,437.3L271.6,437.3z"
        />
        <path
          fill="#E77452"
          d="M301,441.8c-1.1,1-2.4,1.9-3.4,2.7c1.3,0.7,2.7,1.2,4.2,1.6c-0.7,0.7-1.6,1.9-2.1,2.7
		c-1.2-0.4-2.3-0.8-3.3-1.4v2.5c0,0.7,0.1,0.9,0.4,0.9h1.4c0.4,0,1.1,0,1.5-0.1c0.1,0.7,0.1,1.7,0.2,2.4c-0.4,0.1-1.1,0.2-1.7,0.2
		h-1.8c-2.4,0-2.9-1-2.9-3.4v-1.7h-2.7c-0.1,2-0.8,4.2-3.2,5.8c-0.3-0.5-1.2-1.3-1.7-1.9v0.9h-5.8c-0.1,0.7-0.2,1.4-0.3,2h6.1
		c0,0,0,0.8-0.1,1.2c-0.3,3.9-0.7,5.8-1.4,6.6c-0.6,0.7-1.3,0.9-2.3,1c-0.8,0.1-2.3,0.1-3.8,0c-0.1-0.9-0.5-2.1-1-2.9
		c1.5,0.1,2.9,0.1,3.5,0.1c0.5,0,0.8,0,1-0.3c0.4-0.3,0.6-1.3,0.8-3.2h-6.1c0.4-1.9,0.9-4.8,1.1-7.1h5.2v-2h-4.2V448
		c-0.9,0.4-1.7,0.8-2.7,1.1c-0.4-0.8-1.3-1.9-1.9-2.5c1.7-0.5,3.4-1.3,4.9-2.2c-0.8-0.6-1.8-1.3-2.7-1.7l2-1.8
		c1,0.5,2.2,1.2,3.1,1.8c0.6-0.6,1.2-1.2,1.7-1.9h-5.7V438h7.6l0.6-0.1l2.1,1c-1.2,2.9-3.1,5.1-5.5,6.9h3.8v5.8
		c1.8-1.2,2.1-2.6,2.1-3.9v-2.1h5.6c-2.5-2-4.5-4.6-5.9-7.7l2.8-0.8c0.4,1,1,1.9,1.7,2.7c1-0.8,2-1.9,2.7-2.7l2.5,1.8
		c-1.2,1-2.4,2-3.6,2.8c0.5,0.5,1,0.9,1.5,1.3c1.1-0.9,2.4-2.1,3.2-3L301,441.8z M298.8,454.7c-0.7,2.1-1.8,3.8-3.2,5.2
		c1.3,0.7,2.5,1.5,3.4,2l-1.7,2.3c-1-0.7-2.4-1.6-4-2.5c-1.8,1.1-4.1,2-6.5,2.5c-0.3-0.8-0.9-1.9-1.5-2.5c1.9-0.3,3.7-0.9,5.2-1.6
		c-1.4-0.8-2.8-1.6-4.1-2.2l1.2-1.4H287v-2.3h9.5l0.5-0.1L298.8,454.7z M289.2,456.4c1.2,0.6,2.6,1.3,3.9,2c0.7-0.6,1.3-1.3,1.8-2
		H289.2z"
        />
        <path
          fill="#E77452"
          d="M330.1,455.1h-6.5v5.3c0,1.9-0.4,2.7-1.7,3.2c-1.3,0.5-3.1,0.6-5.7,0.6c-0.2-1-0.8-2.4-1.3-3.3
		c1.8,0.1,3.9,0.1,4.4,0.1c0.6,0,0.8-0.2,0.8-0.6v-5c-3.5,3.4-9.2,6.6-14.3,8.2c-0.5-0.9-1.4-2.2-2.2-3c4.1-1,8.6-3,11.8-5.4H306
		c0.6-1.7,1.2-4.3,1.6-6.4l3.6,0.4c-0.2,0.9-0.5,1.9-0.8,2.8h9.6v-3.7h-14.5V445h22.8v3.1h-4.9v3.7h6.5V455.1z M309.4,442.2h-5.5v-3
		h5.5V437h3.4v2.2h3.4v3h-3.4v2.1h-3.4V442.2z M321.1,442.2h-3.5v-3h3.5V437h3.4v2.2h5.6v3h-5.6v2.1h-3.4V442.2z"
        />
        <path
          fill="#E77452"
          d="M359.3,459.6v3.6h-26.2v-3.6h8.2v-14h-7.7v-3.4h5.9c-0.5-1.2-1.3-2.8-2.1-3.9l3.1-1.2c1.1,1.5,2.1,3.4,2.6,4.7
		l-1.1,0.5h7.1c1-1.5,2-3.6,2.7-5.2l3.9,1c-0.9,1.5-1.8,3-2.6,4.2h5.6v3.4H351v14L359.3,459.6L359.3,459.6z M338,447.8
		c1.3,2.8,2.3,6.4,2.6,8.9l-3.4,0.8c-0.2-2.4-1.2-6.1-2.3-8.9L338,447.8z M344.7,459.6h2.8v-14h-2.8V459.6z M351.5,456.6
		c1-2.4,2.2-6.2,2.7-9.1l3.8,0.8c-1,3.2-2.2,6.8-3.3,9.1L351.5,456.6z"
        />
        <path
          fill="#E77452"
          d="M387.6,455.5c-1.6,1.2-3.4,2.3-5.1,3.2c1.8,1.1,4,1.9,6.6,2.4c-0.8,0.7-1.7,2.2-2.2,3.1
		c-6.5-1.5-10.4-4.9-12.9-10.2h-4.2v6.2l6.4-1.3c-0.2,0.9-0.3,2.4-0.3,3.1c-7,1.5-8.6,1.9-9.4,2.3l-0.2,0.1
		c-0.2-0.8-0.9-2.6-1.5-3.4c0.6-0.4,1.5-1,1.5-2.2v-4.7h-4.3v-3.1h4.8V438h18.4v2.8h-14.8v1.6h14v2.7h-14v1.5h14v2.7h-14v1.6h17.9
		v3.1h-3.1L387.6,455.5z M377.7,453.9c0.6,1.1,1.4,2.1,2.4,2.9c1.5-0.9,3.1-2,4.3-2.9H377.7z"
        />
        <path
          fill="#E77452"
          d="M416.3,451.5v12.6h-3.9v-1.6h-20v-11h3.9v7.6h6.1V450H394v-10.6h3.7v7.2h4.8V437h3.8v9.7h5v-7.2h3.8V450h-8.9
		v9.2h6.1v-7.6H416.3z"
        />
        <path
          fill="#E77452"
          d="M424.2,459.3c-0.2,1.7-0.8,3.4-1.3,4.5c-0.6-0.2-1.8-0.4-2.4-0.5c0.7-1.1,1.1-2.8,1.3-4.3L424.2,459.3z
		 M446.7,463.3h-10.5v1h-3v-8.4l-0.3,0.3c-0.4-0.4-1.1-0.9-1.8-1.3c0.5,0.9,0.8,2,0.9,2.7l-2.2,0.8c-0.1-0.3-0.1-0.6-0.2-1
		c-6,0.7-7.1,0.8-7.8,1.1c-0.1-0.4-0.6-1.5-0.9-2c0.7-0.1,1.3-0.5,2.2-1.1c0.4-0.3,1.2-0.9,2.1-1.7c-2.4,0.2-3.1,0.4-3.6,0.5
		c-0.2-0.4-0.6-1.5-1-2c0.4-0.1,0.8-0.4,1.3-0.8c0.4-0.4,1.4-1.5,2.2-2.7h-1.7V443h22.9v5.7h-3.9c0.3,0.7,0.7,1.5,1,2.2h3.9v2.3h-4
		v1.2h3.2v2h-3.2v1.3h3.2v2h-3.2v1.3h4.5V463.3z M427,441.5h-6.3v-2.7h6.3V437h3.4v1.7h2.8v2.7h-2.8v1H427V441.5z M430.4,453.5
		c0.1,0.2,0.2,0.4,0.4,0.7c1.4-1.5,2.7-3.4,3.5-5.4H426l1,0.4c-0.6,0.8-1.4,1.7-2.2,2.5l2.3-0.1c0.5-0.5,1-1.1,1.4-1.6l2.4,1.3
		c-1.4,1.5-3.1,3.1-4.9,4.4l2.8-0.2c-0.2-0.4-0.4-0.9-0.6-1.3L430.4,453.5z M427.3,458.9c0.4,1.3,0.6,3,0.7,4.2l-2.4,0.4
		c0-1.2-0.3-2.9-0.6-4.2L427.3,458.9z M425.4,446.7h3.6V445h-3.6V446.7z M430.4,458.4c0.7,1.2,1.4,2.8,1.6,3.8l-2.4,0.6
		c-0.3-1-0.9-2.7-1.5-3.9L430.4,458.4z M431.8,446.7h3.7V445h-3.7V446.7z M436.7,441.5h-2.5v-2.7h2.5V437h3.5v1.7h6.4v2.7h-6.4v1
		h-3.5V441.5z M437.2,449.1c-0.3,0.6-0.6,1.2-0.9,1.8h2.8c-0.2-0.6-0.4-1.1-0.6-1.6l2.4-0.6h-5L437.2,449.1z M439.3,453.2h-3.1v1.2
		h3.1V453.2z M439.3,456.4h-3.1v1.3h3.1V456.4z M436.2,460.9h3.1v-1.3h-3.1V460.9z M438.2,446.7h3.8V445h-3.8V446.7z"
        />
        <path
          fill="#E77452"
          d="M474.4,445.4c-0.2,12-0.5,16.1-1.3,17.3c-0.6,1-1.2,1.2-2.1,1.4c-0.8,0.2-1.9,0.1-3.1,0.1c0-0.6-0.2-1.3-0.4-2
		h-11.3v1H453v-8.7h15v6.7c0.5,0,1,0,1.3,0c0.4,0,0.6-0.1,0.8-0.5c0.5-0.8,0.8-4.4,0.9-14.6h-15c-0.2,0.3-0.4,0.6-0.5,0.8h12.8v1.7
		h-14c-0.8,1-1.8,2-2.9,3c-0.5-0.7-1.6-1.8-2.4-2.3c2.7-2.1,4.4-4.8,5.2-7.2l0.7,0.1v-0.9h-5.3v-2.9h5.3V437h3.4v1.5h3.8v2.9h-3.8v1
		h-2.8l2,0.3c-0.1,0.4-0.3,0.7-0.5,1.1h17.2L474.4,445.4L474.4,445.4z M467,453.7h-12.7v-4.1H467V453.7z M456.1,456.4v1h2.9v-1
		H456.1z M456.1,460.3h2.9v-1.1h-2.9V460.3z M463.8,451.1h-6.5v1.2h6.5L463.8,451.1L463.8,451.1z M464.9,456.4h-3v1h3V456.4z
		 M464.9,460.3v-1.1h-3v1.1H464.9z M475.7,438.5v2.9h-5v1.7h-3.4v-1.7h-4v-2.9h4V437h3.4v1.5H475.7z"
        />
        <path
          fill="#E77452"
          d="M484.7,454.1c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7
		C480,456.2,482.1,454.1,484.7,454.1z M484.7,461.4c1.5,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6c-1.4,0-2.6,1.2-2.6,2.6
		C482.1,460.3,483.3,461.4,484.7,461.4z"
        />
      </g>
    );
  }
}

export default StoryDDialogText;



// WEBPACK FOOTER //
// ./src/StoryDDialog/components/StoryDDialogText.tsx